import React, { Component, ErrorInfo, ReactNode } from "react"
import { Box, Button, Typography } from "@mui/material"
import { ErrorOutline } from "@mui/icons-material"

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Uncaught error:", error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            gap: 2,
            textAlign: "center",
            px: 2
          }}>
          <ErrorOutline sx={{ fontSize: 64, color: "text.disabled" }} />
          <Typography variant="h5" fontWeight="bold">
            Something went wrong
          </Typography>
          <Typography variant="body2" color="text.secondary" maxWidth={400}>
            An unexpected error occurred. Please refresh the page or try again.
          </Typography>
          <Button variant="contained" onClick={() => this.setState({ hasError: false })}>
            Try Again
          </Button>
        </Box>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
